import { render, staticRenderFns } from "./ItemIterator.vue?vue&type=template&id=5348e4f5&scoped=true"
import script from "./ItemIterator.vue?vue&type=script&lang=ts"
export * from "./ItemIterator.vue?vue&type=script&lang=ts"
import style0 from "./ItemIterator.vue?vue&type=style&index=0&id=5348e4f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348e4f5",
  null
  
)

export default component.exports